import { render, staticRenderFns } from "./standardService.vue?vue&type=template&id=78db6c09&scoped=true&"
import script from "./standardService.vue?vue&type=script&lang=js&"
export * from "./standardService.vue?vue&type=script&lang=js&"
import style0 from "./standardService.vue?vue&type=style&index=0&id=78db6c09&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78db6c09",
  null
  
)

export default component.exports